import bufferedRows from '@baserow/modules/database/store/view/bufferedRows'
import MapService from '@baserow/modules/database/services/view/map'
import { getRowMetadata } from '@baserow/modules/database/utils/row'

export function populateRow(row, metadata = {}) {
  row._ = {
    metadata: getRowMetadata(row, metadata),
    dragging: false,
  }
  return row
}

const mapBufferedRows = bufferedRows({
  service: MapService,
  customPopulateRow: populateRow,
})

export const state = () => ({
  ...mapBufferedRows.state(),
})

export const mutations = {
  ...mapBufferedRows.mutations,
}

export const actions = {
  ...mapBufferedRows.actions,
  async fetchInitial(
    { dispatch },
    { viewId, fields, adhocFiltering, adhocSorting }
  ) {
    const data = await dispatch('fetchInitialRows', {
      viewId,
      fields,
      initialRowArguments: { includeFieldOptions: true },
      adhocFiltering,
      adhocSorting,
    })
    await dispatch('forceUpdateAllFieldOptions', data.field_options)
  },
}

export const getters = {
  ...mapBufferedRows.getters,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
